import {doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export class Action
{
	constructor(name,chemical)
	{
		this.name = name;
		this.id = name;
		this.chemical = chemical;
	}

	async submitAsNew()
	{
		const {id, ...rest} = this;
		var projectRef = doc(db, "Actions", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Actions", id), { ...rest });
			return resp;
		}
	}

	static async submitUpdate(p)
	{
		const {id, ...rest} = p;
		let resp = await setDoc(doc(db, "Actions", id), { ...rest });
		return resp;
	}

	static async getAll()
	{
		return await getCollection("Actions");
	}

	static async deleteAndUpdate(selection,actions,setActions)
	{
		actions = actions.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Actions", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setActions(actions);
	}
}